export const landingRoutes = [
    {
        path: '',
        name: 'Home',
        exact: true,
        component: () => import('../views/Landing.vue'),
        meta: {
            breadcrumb: [{ label: 'Home' }],
        },
    },
];
